import React from 'react';

import { TableBody } from '@mui/material';

import { SchoolLevelHelper } from '../../../../helpers/school-level.helper';
import { StaffHelper } from '../../../../helpers/staff.helper';
import { IStaff, IStaffGroup } from '../../../../types/staff.type';
import { StringUtils } from '../../../../utils/string.utils';
import { IOptions } from '../../types';
import StaffItem from '../StaffItem';
import StaffListGroup from '../StaffListGroup';

interface IProps {
  staff: IStaff[];
  options: IOptions;
}

const StaffListBody = React.memo(({ staff, options }: IProps) => {
  const renderStaff = React.useMemo(() => {
    if (!staff?.length) {
      return null;
    }

    const grouped = SchoolLevelHelper.groupByCode<IStaffGroup>(staff);

    return Object.entries(grouped)
      .map(([group, groupedStaff]) => (
        <React.Fragment key={StringUtils.random(36)}>
          {groupedStaff.map((staffItem) => (
            <StaffItem key={StaffHelper.makeKey(staffItem)} staff={staffItem} options={options} />
          ))}

          <StaffListGroup groupName={group} staff={groupedStaff} options={options} />
        </React.Fragment>
      ))
      .flat();
  }, [staff, options]);

  return <TableBody>{renderStaff}</TableBody>;
});

export default StaffListBody;
